import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { observableStore } from './stores/game-store';
import TuneMenu from './components/tune-menu';
import MultiGame from './components/multi-game';
import AdventureGame from './components/adventure-game';
import DevTools from 'mobx-react-devtools';
import createHistory from 'history/createBrowserHistory';
import "babel-polyfill";
const  ReactGA = require('react-ga');

const history = createHistory()
history.listen((location, action) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
});

const composedMultiGame = ((props) => {
  return (<MultiGame {...props} store={observableStore} />);
});
const composedAdventure = ( props => <AdventureGame {...props} store={observableStore} /> );
const App = (props) => {
  return (
  <BrowserRouter history={history}>
    <div className="App">
      <Switch>
        <Redirect from="/" exact to="/tune/adventure/" />
        <Route path="/tune/" exact component={TuneMenu}/>
        <Route path="/tune/adventure/" component={composedAdventure} />
        <Route path="/tune/multi/:type" component={composedMultiGame}/>
      </Switch>
      {process.env.NODE_ENV === "development" ?
          <DevTools />
          :
          null}
    </div>
  </BrowserRouter>
  );
};
export default App;



// WEBPACK FOOTER //
// ./src/App.js